import vars from './definitions';

/**
 * Circle size configurations needed for Svg calculation.
 *
 * @type {Object}
 * @private
 */
const sizes = {
  sm: {
    width: parseInt(vars.uxSpinnerSmSize, 10),
    strokeWidth: vars.uxSpinnerSmStrokeWidth
  },
  md: {
    width: parseInt(vars.uxSpinnerMdSize, 10),
    strokeWidth: vars.uxSpinnerMdStrokeWidth
  },
  lg: {
    width: parseInt(vars.uxSpinnerLgSize, 10),
    strokeWidth: vars.uxSpinnerLgStrokeWidth
  }
};

/**
 * Generate the various of styles of the spinner.
 *
 * @param {String} size Size of the spinner.
 * @returns {Object} Design styles sizes.
 * @private
 */
export default function prepareSize(size) {

  switch (size) {
    case 'small':
    case 'sm':
      size = sizes.sm;
      break;

    case 'large':
    case 'lg':
      size = sizes.lg;
      break;

    default:
      size = sizes.md;
  }

  return size;
}
